import { render, staticRenderFns } from "./BloodGlucose.vue?vue&type=template&id=0c791816&"
import script from "./BloodGlucose.vue?vue&type=script&lang=js&"
export * from "./BloodGlucose.vue?vue&type=script&lang=js&"
import style0 from "./BloodGlucose.vue?vue&type=style&index=0&id=0c791816&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports